import React from 'react';
import { ArrowLeftIcon, ClockIcon, UserIcon } from 'lucide-react';
export function TaxCodeAuditHistory({
  taxCode,
  auditEntries,
  onBack,
  locale = 'en-US'
}) {
  return <div className="bg-white shadow overflow-hidden sm:rounded-lg" data-id="element-11924">
      <div className="px-4 py-5 sm:px-6 border-b border-gray-200" data-id="element-11925">
        <div className="flex justify-between items-center" data-id="element-11926">
          <div data-id="element-11927">
            <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-11928">
              Audit History
            </h3>
            <p className="mt-1 max-w-2xl text-sm text-gray-500" data-id="element-11929">
              Tracking changes for tax code: {taxCode.code}
            </p>
          </div>
          <button onClick={onBack} className="inline-flex items-center px-3 py-1.5 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-11930">
            <ArrowLeftIcon className="h-4 w-4 mr-1.5" data-id="element-11931" />
            Back to Tax Codes
          </button>
        </div>
      </div>
      <div className="border-t border-gray-200" data-id="element-11932">
        {auditEntries.length === 0 ? <div className="px-4 py-5 sm:p-6 text-center text-gray-500" data-id="element-11933">
            No audit history available for this tax code.
          </div> : <div className="px-4 py-5 sm:p-6" data-id="element-11934">
            <div className="flow-root" data-id="element-11935">
              <ul className="-mb-8" data-id="element-11936">
                {auditEntries.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp)).map((entry, index) => <li key={entry.id} data-id="element-11937">
                      <div className="relative pb-8" data-id="element-11938">
                        {index !== auditEntries.length - 1 ? <span className="absolute top-4 left-4 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true" data-id="element-11939"></span> : null}
                        <div className="relative flex space-x-3" data-id="element-11940">
                          <div data-id="element-11941">
                            <span className="h-8 w-8 rounded-full bg-indigo-100 flex items-center justify-center ring-8 ring-white" data-id="element-11942">
                              <ClockIcon className="h-5 w-5 text-indigo-600" data-id="element-11943" />
                            </span>
                          </div>
                          <div className="min-w-0 flex-1 pt-1.5 flex justify-between space-x-4" data-id="element-11944">
                            <div data-id="element-11945">
                              <p className="text-sm text-gray-900" data-id="element-11946">
                                <span className="font-medium" data-id="element-11947">
                                  {entry.action}
                                </span>{' '}
                                field{' '}
                                <span className="font-medium" data-id="element-11948">
                                  {entry.field}
                                </span>
                              </p>
                              <div className="mt-2 flex items-center text-sm text-gray-500" data-id="element-11949">
                                <div className="bg-gray-100 rounded px-2 py-1 mr-2" data-id="element-11950">
                                  <span className="text-xs text-gray-800 font-mono" data-id="element-11951">
                                    {formatAuditValue(entry.oldValue)}
                                  </span>
                                </div>
                                <span className="mx-2" data-id="element-11952">→</span>
                                <div className="bg-green-100 rounded px-2 py-1" data-id="element-11953">
                                  <span className="text-xs text-green-800 font-mono" data-id="element-11954">
                                    {formatAuditValue(entry.newValue)}
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="text-right text-sm whitespace-nowrap text-gray-500" data-id="element-11955">
                              <div className="flex items-center" data-id="element-11956">
                                <UserIcon className="h-4 w-4 mr-1 text-gray-400" data-id="element-11957" />
                                <span data-id="element-11958">{entry.userName}</span>
                              </div>
                              <time dateTime={entry.timestamp} data-id="element-11959">
                                {new Date(entry.timestamp).toLocaleString(locale)}
                              </time>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>)}
              </ul>
            </div>
          </div>}
      </div>
    </div>;
}
// Helper function to format audit values for display
function formatAuditValue(value) {
  if (value === 'true') return 'Yes';
  if (value === 'false') return 'No';
  if (value === '') return '(empty)';
  if (value === 'null' || value === 'undefined') return '(none)';
  return value;
}